export const Blank = ({children}) => {
  return children
}
